import { render, staticRenderFns } from "./FeedbackMobile.vue?vue&type=template&id=3b40a534&scoped=true&"
import script from "./FeedbackMobile.vue?vue&type=script&lang=js&"
export * from "./FeedbackMobile.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackMobile.vue?vue&type=style&index=0&id=3b40a534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b40a534",
  null
  
)

export default component.exports